(function($) {
    'use strict';
    jQuery(document).ready(function($) {
     
      function kutetheme_ovic_clone_header_ontop(){
        if( $('#header').length > 0 && $('#header-ontop').length >0 ){
          if( $('#header-ontop').find('.header').length <= 0 ){
            var content = $( "#header" ).clone();
            content.removeAttr('id');
            content.appendTo( "#header-ontop" );
          }
        }
      }
      
      /* END MENU*/      
      
       var enable_effect_menu = $("#sticky_menu").val();  
       if(enable_effect_menu == 'false'){
         $("#header-ontop").attr('style','display:none!important');
       }else{
         
       }
          
      var offset = $('#header').offset();
      var stickyHeaderTop = parseInt(offset.top);
      var stickyHeaderTop = parseInt($('#header').height());
      
      stickyHeaderTop += stickyHeaderTop;
        
      jQuery(window).scroll(function() {
        
        var h = jQuery(this).scrollTop();
        var width = $(window).width();
        if(width > 991){

          if((h > stickyHeaderTop) ){
            kutetheme_ovic_clone_header_ontop();
            $('#header-ontop').addClass('on-sticky');
            $('#header-ontop').find('.header').addClass('ontop');
          }else{
            $('#header-ontop').removeClass('on-sticky');
            $('#header-ontop').find('.header').removeClass('ontop');
          }
        }else{
          $('#header-ontop').find('.header').removeClass('ontop');
          $('#header-ontop').removeClass('on-sticky');
        }       
        
      });
    
      /* END MENU*/
      
      /* Add class for home 20 */
      var val_home = $("#select_home").val();
      
      if(val_home == 20){  $("body").addClass("home20");}
      
      /* Click bar-category for home 20 */
      var click_bar = 0;
      $(document).on('click',".bar-category", function(event) {
        click_bar++;
        if(click_bar % 2 !=0){
          $("#menu-category-menu").show();   
        }else{
          $("#menu-category-menu").hide();             
        }   
             
      })
      
      /* End home 20 */   
/* ---------------------------------------------
     Slipt Text
--------------------------------------------- */
      function readMore(string, maxWords) {       
        var strippedString = $("<p>" + string + "</p>").text().trim();      
        var array = strippedString.split(" ");
        var string = array.splice(0, maxWords).join(" ");

        if(array.length > maxWords) {
          string += "...";
        }

        return string ;
      }
      
/* ---------------------------------------------
     Scripts Convert Currency
--------------------------------------------- */
      function convert_currency_andy(value, type) {
        var newCurrency = Currency.currentCurrency;
        if(Currency.currentCurrency=== undefined) newCurrency= 'USD';
        var oldCurrency = shopCurrency;
        if (isNaN(value)) {
          value = 0.0;
        }
        
        var cents = 0.0;
        var oldFormat = Currency.moneyFormats['USD'][Currency.format] || '';
        var newFormat = Currency.moneyFormats[Currency.currentCurrency][Currency.format] || '';
        if(Currency.currentCurrency=== undefined) {
            var newFormat = Currency.moneyFormats['USD'][Currency.format] || '';
        }
                                                     
        if (oldFormat.indexOf('amount_no_decimals') !== -1) {
             cents = Currency.convert(parseInt(value, 10) * 100, oldCurrency, newCurrency);
        } else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
             cents = Currency.convert(parseInt(value, 10) / 10, oldCurrency, newCurrency);
        } else {
             cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
        }
        if (type == 'nosymbol') {
          return cents; 
        }    
                                          
        var my_data = Currency.formatMoney(cents, newFormat);
        return my_data;

      }
                                                  
/* ---------------------------------------------
     Show cart dropdown
--------------------------------------------- */                                                    
      function show_dropdown_cart(){
       
        $.ajax({
          url: ' /cart.js',
          type: 'GET', 
          dataType: 'json',
          success: function(data) {
            $(".cartCount").text(data.item_count);                                                  
            $(".minicart-content").empty();   
                                                  
            var html = '';                                      
            if (data.item_count > 0) {                 
                  var index_item = 0;
					
                  html = html + '<div class="inner">';
          			html = html + '<span class="close-minicart"></span>';
          			html = html + '<h3 class="mini-cart-title">Your cart</h3>';
          			html = html + '<span class="minicart-subtext">You have <span>'+data.item_count+ ' item(s)</span> in your cart</span>';
          			html = html + '<ul class="list-product clear-both">';

                        $.each(data.items, function(index, el) {
                        html = html + '<li class="product-item clear-both" id="item-'+el.id+'">';
                          html = html + '<div class="thumb">';
                            html = html + '<img width="120" height="130" src="'+el.image +'" alt="'+el.title+'">';
                          html = html + '</div>';
                          html = html + '<div class="info">';
                            html = html + '<h4 class="product-name">';
                              html = html + '<a href="'+el.url+'">'+el.title+'</a>';
                              html = html + '<span class="qty">' + el.quantity+ ' × <span class="amount"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency_andy(el.price,'xx')+'">'+convert_currency_andy(el.price,'xx')+'</span></span></span> ';                               
                            html = html + '</h4>';
                            html = html + '<a class="remove remove-item" href="/cart/change/'+el.id+'?quantity=0" data-id="'+el.id+'" title="Remove this item">Delete</a>';                
                          html = html + '</div>';
                        html = html + '</li>';
                        })  
          			html = html + '</ul>';
                    html = html + '<div class="sub-total clear-both">';
                      html = html + 'Cart Totals :<span class=" amount cartCost"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency_andy(data.price,'11')+'" data-currency-'+Currency.currentCurrency+'="'+convert_currency_andy(data.price,'11')+'" data-currency="'+Currency.currentCurrency+'"></span></span>';
                    html = html + '</div>';
                    html = html + '<div class="group-button">';
                      html = html + '<a href="/cart" class="button">Your cart</a>';
                      html = html + '<a href="/checkout" class="button black checkout wc-forward">Check out</a>';
                    html = html + '</div>';
                  html = html + '</div>';

              }else{                    
                    html = html + '<div class="inner">';
          				html = html + '<span class="close-minicart"></span>';
          				html = html + '<h3 class="mini-cart-title">Your cart is currently empty.</h3>';
          				html = html + '<div class="group-button" style="width: 219px;">';        
            				html = html + '<a href="/collections/all" class="button">Continue shopping</a>';
          				html = html + '</div>';
        			html = html + '</div>';                              	
              }
               
              $(".minicart-content").html(html);
              $(".cartCost").html(convert_currency_andy(data.total_price )); 
            }

           
          })       
      }
                                                  
/* ---------------------------------------------
     Add wishlist function
--------------------------------------------- */  
                                                  
      /* wishlist */
        $(document).on('click',".wishlist", function(event) {
            var $this = $(this);
            
            /* Act on the event */
            var myid = $(this).data('form');
            var args = $("input[value='" + myid + "']").first().parent('form').serialize();
            
            event.preventDefault();                                      
            $("#loading").show();
                                                  
            $.ajax({
                url: '/contact',
                type: 'POST',
                dataType: 'html',
                data: args,
                success: function(data, status) {
                    if (status == "success") {
                       $('[data-form="'+myid+'"]').hide(600).next('a.added-wishlist').css({visibility:'visible',display:'inline-block'});
                        // $this.hide(600).next('a.added-wishlist').show(700);
                        var count = $("#number_wishlist").text();  
                        count++;
                        $(".wishlist_count").text(count);
                                                  
                        $("#loading").hide(500);
                        swal("Success!", "Added success to wishlist!", "success");
                    } else {
                        $("#loading").hide(500);
                        sweetAlert("Oops...", "Please login to use wishlist!", "error");
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
        			$("#loading").hide(500);
      			}                                  
            });
        });
                                                  
/* ---------------------------------------------
     Login before using wishlist
--------------------------------------------- */                                           
        $(document).on('click',".wishlist-login", function(event) {
            event.preventDefault();
            /* Act on the event */
          swal({
            title: "Oops...",
            text: "Please login to use wishlist!",
            type: "warning",
            confirmButtonText: "Login",
            timer: 5000,
            showCancelButton: true
          },
               function() {
            window.location.href = 'https://' + Shopify.shop + '/account/login'
          });

        });

        $("#addtocart-message").hide('slow');  
                                                  
/* ---------------------------------------------
     Add product in wishlist
--------------------------------------------- */                                                    
                                                  
        $(document).on('click',".wishlist-addtocart", function(event) {
          event.preventDefault();
          /* Add product in wishlist to cart*/
          var $this = $(this);
          $("#loading").show();
          var value = $(this).data('wid');
          $('.product-select').val(value);
          var args = $('.add-variant').serialize();
          $.ajax({
            url: $('.add-variant').attr('action'),
            type: 'POST',
            dataType: 'html',
            data: args,
            success: function(data, status) {
              show_dropdown_cart();
              $("#addtocart-message").show('slow');
              var xx = $this.data('title');
              $("."+value).hide();
              $("#title-addtocart").text(xx); 
              if (status == "success") {
                $this.hide(600).next('.wishlist-addedtocart').removeClass('wishlist-addedtocart').show(700);
                $("#loading").hide(500);

              } else {
                $("#loading").hide(500);
                sweetAlert("Oops...", "An error occurred when add to cart!", "error");
              }
            },
            error: function (xhr, ajaxOptions, thrownError) {
        		$("#loading").hide(500);
      		}  
            
          });
        });       
/* ---------------------------------------------
     Remove Wishlist
--------------------------------------------- */  
        $('.wishlist-remove').on('click', function(event) {
            event.preventDefault();
            $("#loading").show();
            /* Remove product from wishlist*/
            var $this = $(this);
            var value = $(this).data('wid');
            $('.remove-value').val(value);
            var args = $('.contact-form').serialize();
            $.ajax({
                url: $('.contact-form').attr('action'),
                type: 'POST',
                dataType: 'html',
                data: args,
                success: function(data, status) {
                    if (status == "success") {
                        $("tr." + value).slideUp(600);
                        $("#loading").hide(500);
                        var count = $("#number_wishlist").text();  
                        count--;
                        $(".wishlist_count").text(count);                          
                        swal({
                            title: "Auto close alert!",
                            text: "Remove success.",
                            timer: 1000,
                            showConfirmButton: false
                        });
                    } else {
                        $("#loading").hide(500);
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
        			$("#loading").hide(500);
      			}  
            });
        });
      /* end wishlist */
                                                  
/* ---------------------------------------------
     Function of compare
--------------------------------------------- */  
    /* Compare Product*/
    var storage = $.localStorage;
    var compare = {};
    var total_compare =  4 ;
    if (storage.isSet('compare')) {
      compare = storage.get('compare');
    } else {
      storage.set('compare', {});
    }
    function compare_to_table(data) {
      if (Object.keys(data).length <= 0) {
        return '';
      }
      var html = '';
      var i = 0;

      var end_check = (Object.keys(data).length - 1);
      var width_tr = (end_check > 0) ? (90 / (Object.keys(data).length)) : 90;
      var data_html = '';
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        data_html = data_html + '<th class=" ' + el.handle + '"><button type="button" class="close remove-compare center-block" aria-label="Close" data-handle="' + el.handle + '"><span aria-hidden="true" class="remove-compare-x" title="Delete" style="font-size: 13px;"></span></button></th>';
        //Start title 
        if (i == 0) {
          html = html + '<tr >';
          html = html + '<th width="10%" > Title </th>';
        }
        html = html + '<td width="' + width_tr + '%"  class="' + el.handle + '"> ' + el.title + '  </td>';
        if (i >= end_check) {
          html = html + '</tr>';
        }
        // End Title 
      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="10%" > Image </th>';

        }
        // start product image
        html = html + '<td width="' + width_tr + '%" class="' + el.handle + '"> <div style="width:150px; height:auto; margin:0 auto;"><img style="float:left;" src="' + el.featured_image + '"  width="150"/> ' + '<div class="product-price" style="width: 150px; margin: 0;text-align:center;  clear:left; float: left;" > ';
        if (is_sale) {
          html = html + '<strong style="display:block;">On Sale</strong>' + '<span class="price-sale"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency_andy(el.price,'11')+'">'+convert_currency_andy(el.price,'11')+'</span></span>';
        } else {
          html = html + '<span class="price-sale"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency_andy(el.price,'11')+'">'+convert_currency_andy(el.price,'11')+'</span></span>';
        }
                   
        html = html + '</div>';
        //convert_currency_andy(el.price,'3');
        if (el.variants.length > 1) {
          html = html + '<div style="width: 150px; margin: 0;text-align:center; clear:left; float: left;"><a style="cursor:pointer; padding: 15px;" onclick="location.href=\'/products/' + el.handle + '\'">Select Options</a></div>';
        } else {
          html = html + '<div style="width: 150px; margin: 0;text-align:center; clear:left; float: left;"><a style="cursor:pointer; padding: 15px;" href="#" title="ADD TO CART" data-pid="' + el.variants[0].id + '" class="boutique__add-to-cart button add_to_cart_button ">ADD TO CART</a></div>';
        }
        html = html + ' </div></td>';

        if (i >= end_check) {
          html = html + '</tr>';
        }
        // End product image
      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="10%" > Description </th>';

        }
        html = html + '<td width="' + width_tr + '%" class="' + el.handle + ' "> <p class="description-compare" style="text-align:justify;"> '+readMore(el.description,25)+'... </p> </td>';
        if (i >= end_check) {
          html = html + '<tr>';
        }

      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="10%" > Available </th>';

        }

        var avai_stock = (el.available) ? 'Available In stock' : 'Unavailable In stock';
        html = html + '<td   width="' + width_tr + '%" class="available-stock ' + el.handle + '"> <p> ' + avai_stock + ' </p> </td>';
        if (i >= end_check) {
          html = html + '<tr>';
        }

      }
      $(".th-compare").html('<th></th>'+data_html);
      $("#table-compare").html(html);
    }
      
      function countProperties(obj) {
        var count = 0;

        for(var prop in obj) {
          if(obj.hasOwnProperty(prop))
            ++count;
        }

        return count;
      } 
      if (!$.isEmptyObject(compare)) {
        //compare = {};
        var list_id = '';
        var json_compare = [];
        var check_end = 0;
        var compare_size = (Object.keys(compare).length - 1);
        $.each(compare, function(index, el) {
          $("[data-pid='"+el+"']").addClass('added');
          var json_url = "/products/" + el + ".js";
          if ($.trim(el) != "") {
            jQuery.getJSON(json_url, function(product) {
              json_compare[check_end] = product;
              if (check_end >= compare_size) {
                $("#compare-sidebar .no-compare").hide();
                compare_to_table(json_compare);
              }
              check_end += 1;
            });

          }
		  
        });
        $(".compare_count").text("0");  
        $(".compare_count").text(countProperties(compare)); 
        $(".compare_show_count").text(countProperties(compare)); 
        $("#compare_value").val(countProperties(compare));
      } else {
        compare = {};
        $(".error-compare").show();
      }
      
/* ---------------------------------------------
     Compare Modal
--------------------------------------------- */        
 	function modal_compare(){
      if (!$.isEmptyObject(compare)) {
        // $(".error-compare").hide(20);
        var list_id = '';
        var json_compare = [];
        var check_end = 0;
        var compare_size = (Object.keys(compare).length - 1);
        $.each(compare, function(index, el) {
          var json_url = "/products/" + el + ".js";
          if ($.trim(el) != "") {
            jQuery.getJSON(json_url, function(product) {
              json_compare[check_end] = product;
              if (check_end >= compare_size) {
                compare_to_table(json_compare);
              }
              check_end += 1;
            });

          }

        });
        $("#moda-compare").modal('show');
      }

    }
/* ---------------------------------------------
     Compare action
--------------------------------------------- */     
    $(document).on('click','.show_compare', function(event) {
      if (!$.isEmptyObject(compare)) {
        modal_compare(compare);
      } else {
        compare = {};
        modal_compare(compare);
      }
      
    })
    $(document).on('click','.compare', function(event) {

      event.preventDefault();
      $("#loading").show();
      /* Act on the event */
      var $this = $(this);
      var pid = $(this).data('pid');

      compare = storage.get('compare');	
      //compare = {};
      if ($.isEmptyObject(compare)) {
        compare = {};
      }
      var check_compare = true;
      if (Object.keys(compare).length >= total_compare) {
        swal({
          title: "info",
          text: "Product Added over 4 product !. Do you want to compare 4 added product ?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4cae4c",
          confirmButtonText: "Yes,I want view it!",
          timer: 3000,
          cancelButtonText: "Continue",
          closeOnConfirm: true
        },
             function() {
                  
               modal_compare(compare);
            
        });
      } else {
        for (var i = 1; i <= total_compare; i++) {
          if (compare['p' + i] == "" || compare['p' + i] == undefined) {
            compare['p' + i] = pid;
            break;
          } else if (compare['p' + i] == pid) {
            $this.addClass('added');
            check_compare = false;
            modal_compare(compare);
            break;
          }
        }
        
        
        if (check_compare) {
          storage.set('compare', compare);
          modal_compare(compare);
          $this.addClass('add-success');
          $("[data-pid='"+pid+"']").addClass('added');
          
          var count = parseInt($("#compare_value").val());   
          $(".compare_count").text("");          
          count++;          
          $(".compare_count").text(count);  
          $("#compare_value").val(count);
        }
      }
      $("#loading").hide(500);
    });
      
/* ---------------------------------------------
     Remove compare
--------------------------------------------- */  
    $(document).on('click', '.remove-compare', function(event) {
      event.preventDefault();
      /* Act on the event */

      var id = $(this).data('handle');
      $("." + id).fadeOut(600).remove();
      $("[data-pid='"+id+"']").removeClass('added add-success');
      $.each(compare, function(index, el) {
        if (el == id) {
          compare[index] = "";
          delete compare[index];
        }
      });
      storage.set('compare', compare);
      var count = parseInt($("#compare_value").val());  
      count--;
      $(".compare_count").text(count); 
      $(".compare_show_count").text(count);
      $("#compare_value").val(count);
     
    });
    /** End compare */

/* ---------------------------------------------
     Click compare setting
--------------------------------------------- */  
    $(document).on('click', '.compare_setting', function(event) {
      event.preventDefault();
      if (!$.isEmptyObject(compare)) {
        modal_compare(compare);
      } else {
        compare = {};
        modal_compare(compare);
      }
     $(".close-account-control").trigger("click");
    });
    /** End compare */
/* ---------------------------------------------
     Quick view modal
--------------------------------------------- */  
         $(document).on('click','.quick-view' , function(event) {
            event.preventDefault();
            /* Act on the event */
            $("#loading").fadeIn(300);
            var url = $(this).attr('href');
            $("#quick-view-modal .modal-content").load(url + " #product-single", function() {
              $("#quick-view-modal").modal('show');
              var html = "";
              html = html + "<span class='adding'></span><span class='added'></span><span id='AddToCartText'>Add to Cart</span>";
              $("#quick-view-modal #AddToCart").html(html);
               setTimeout(function() {
                   //theme.productImageGallery();
                 
          
                 $(document).on('click', "#ProductPhoto",function(event) {
                   var id = $(this).children('img').data('imageId');
                   $("#ProductThumbs").magnificPopup({
                    delegate: 'a', // child items selector, by clicking on it popup will open
                    type: 'image',
                    gallery: {
                      enabled: true,
                      navigateByImgClick: false,
                      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
                      tPrev: 'translation missing: en.products.zoom.prev',
                      tNext: 'translation missing: en.products.zoom.next'
                    },
                     callbacks: {
                      open: function(){
                        $('html').css('overflow-y','hidden');
                      },
                      close: function(){
                        $('html').css('overflow-y','');
                      $("#ProductThumbs").off('click');
                      }
                    },
                    // other options
                  });
                   $("#ProductThumbs .product-single__thumbnail[data-image-id='"+id+"']").trigger('click');
                 });  
//                  $(document).on('click','.mfp-close'),function(){
                 
//                  });
                                 
               }, 200);
              $("#loading").hide();
            });
        });
        /**
         * End quickview
         */
    
      
      
      
      //Get PID of variant product make by Andy Dao 19/04/2017
      function get_pid_variant(option){
      var result  = $("#product-selectors").val();
            $("#product-selectors option").each(function(){
                var str = $(this).text();

                var arr = str.split(' - ');
                arr[arr.length] = $(this).val();

                var ok = true;
                var count = 0;

              for(var i = 0; i < option.length; i++){
                for(var j = 0; j< arr.length; j++){
                  if(option.length > 1){
                        var tg = arr[j];
                    }else{
                        var tg = arr[j]; 
                    }

                  var val = tg.split(' / ');

                  for(var k=0; k < val.length; k++){
                    if(option[i] == val[k]){
                      count++;
                    }
                  }              
                }
              }
              if(count != option.length){
                ok = false;
              }

              if (ok==true){
                result =  arr[arr.length - 1];
              }          
            });
        return result;


      }
/* ---------------------------------------------
     Show modal cart
--------------------------------------------- */  

      function show_cart(data) {
        if (data.item_count > 0) {
          var html = '';
          $.each(data.items, function(index, el) {
            html = html + '<li> <h3 class="cart-title"> ' + el.title + '  </h3><div class="cart-image">';
            html = html + ' <img src="' + el.image + '" width="50" /> </div> ';
            html = html + ' <p> Price <strong> ' + el.price + ' </strong> </p>';
            html = html + ' <p> Quantity <strong> ' + el.quantity + ' </strong> </p></li>';
          });

          $("#quick-view-modal").modal('show');

          $("#quick-view-modal .modal-content").html(html);
          } else {
          sweetAlert("Oops...", "Cart is empty!", "error");
        }
      }
      
      $(document).on('click',".email_to_friend",function(event){
      		$("#email_to_friend").modal('show');
      })
/* ---------------------------------------------
     Add to cart
--------------------------------------------- */   
      
     //Make by Andy Dao 19/04/2017
     //Make by Andy Dao 19/04/2017     
  	  var change = false;
  	  //End 
  	  var id_new ="";
  	  jQuery('.swatch :radio').change(function() {
        var option = [];
  	  	var index = 0;
        change = true;
        if (change ==  true){         
          $(".swatch-element input:checked:enabled").each(function(){
            option[index] = $(this).attr("value");  
            index++;
          });          
          id_new = get_pid_variant(option); 
          $("#product-selectors").val(id_new).change();
          var text_option_id  = $("#product-selectors option[value='"+id_new+"']").text();
          var arr = text_option_id.split(' - ');
          var new_price = arr[arr.length-1];
          $(".total-price span").text(new_price);
          $("#ProductPrice").text(new_price);  
          
          
          var handle_product  = $("#handle_product").val();
          $.getJSON('/products/'+handle_product+'.js', function(response) {

            var variant_img ="";
            var variant_img_id = "";
            for (var i = 0; i < response.variants.length;i++){
              if(response.variants[i].id == id){

                variant_img = response.variants[i].featured_image.src;
                variant_img_id = response.variants[i].featured_image.id;
                break;
              }
            }

            //Change main product image and zoom image
            if(variant_img !=""){

              var arr = variant_img.split('.');
              var new_url = "";
              for(var i=0; i < arr.length-1; i++){
                if(i!= (arr.length -2)){
                  new_url += arr[i]+'.';
                }else{
                  new_url += arr[i]+'_1024x1024.';
                }  
              }
              new_url += arr[arr.length-1];
              $("#ProductPhoto img").first().attr('src',new_url);
              $("#ProductPhoto img").first().attr('data-zoom',new_url);

              $("#ProductPhoto img").last().attr('src',new_url);
              $("#ProductPhoto img").last().attr('data-zoom',new_url);
            }

            //Change thumbnai image which is actived
            if(variant_img_id !=""){
              $(".product-single__thumbnail").removeClass('active');
              $("#ProductThumbs").find("[data-image-id='" + variant_img_id + "']").addClass("active");

            }
          });
          
          
        }
        
        
        
        
      });      
  	  var option = [];
  	  var index = 0;
      
      $(document).on('click',".add_to_cart_button", function(event) {
        
        $(this).attr('disabled','disabled').css('pointer-events', 'none');
        
        var $this = $(this);       
        
        $this.css({'opacity':'.5'});
        
        event.preventDefault();
       
        var id= $("#productSelect").val();
        
        var quanlity =  $("#Quantity").val();
        
        if(jQuery.type(id) === "undefined" && jQuery.type(quanlity) == 1){
          id =    $(this).data('pid');          
          quanlity = 1;
        }else if (jQuery.type(quanlity) != 1 && jQuery.type(id) === "undefined"){
          id =    $(this).data('pid');          
          quanlity = quanlity;
        }
        
        //Make by Andy Dao 19/04/2017
        if(id_new!=""){
           id = id_new; 
        }
        //End 
        
        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'json',
          data: {
            quantity: quanlity,
            id: id
          },  
          success: function(response) {
            
            show_dropdown_cart();
            
            $('.add_to_cart_button').removeAttr("disabled").css('pointer-events', 'auto');
            
            $this.addClass('added-cart').attr('title',"View Cart").attr("href","/cart");
            $this.removeClass("add_to_cart_button");
            $this.text("View cart");
            $this.css({'opacity':'1'});            
           
          }
        });
      });
      
      $(document).on('click',".remove-item",function(event){
        event.preventDefault();
        var id = $(this).data('id');
        
        $.ajax({
          url:'/cart/update.js',
          type: 'POST', 
          dataType: 'json',
          data:"updates["+id+"]=0",
          success: function(data) {
            $(".cartCost").text(convert_currency_andy(data.total_price));
            $(".cartCount").text(data.item_count);
            $("#item-"+id).remove();
            show_dropdown_cart();
          }
        });
       
        
       
      });
      $(document).on('change',"[id^='updates_']",function(event){
        event.preventDefault();
        var id = $(this).attr('id');
        var first_pos = id.indexOf('_')+1;
        var last_pos  = id.length;
        var val_id 	=	id.substr(first_pos, last_pos);

        var quanlity =	$(this).val();
        
       $.ajax({
          url:'/cart/update.js',
          type: 'POST', 
          dataType: 'json',
          data:"updates["+val_id+"]="+quanlity+"", 
          success: function(data) {
            $(".cartCost").text(convert_currency_andy(data.total_price));
            $(".cartCount").text(data.item_count);
            show_dropdown_cart();
          }
        });
         
       
      });
      
/* ---------------------------------------------
     Currency Choose
--------------------------------------------- */
      $(document).on('mouseover','.box-settings',function(){
        var names = $('.currency-lists ul li.active a').attr('class');
        var name_check = $('.currency-picker__wrapper .chosen-single span').first().text();
        if(names != name_check ){
          $('.currency-lists ul li').removeAttr("class");
          $('.currency-lists ul li a.' + name_check + '').parent("li").attr("class","active");
        }else{
          $('.currency-lists ul li a.' + name_check + '').parent("li").attr("class","active");
        }
      });
      $(document).on('click','.currency-lists ul li',function(e){
        $('.currency-lists ul li').removeClass("active");        
        $(this).addClass("active");
        var name_currency = $(this).attr('data-value');
        $('.currency-picker__wrapper .chosen-single span').text(name_currency);
        $('.currency-picker').val(name_currency);
        $('.currency-picker').val(name_currency).change();
        Currency.cookie.write(name_currency);
        $('.lang-currency').empty();
        var id = $(this).attr("data-value");       
        $('.lang-currency').append($(".currency-lists ."+id).text());
        
        $(".close-account-control").trigger("click");
      });

                                                                                                                        
      if (cookieCurrency != null) {        
        $("."+cookieCurrency).addClass('active');
        $('.lang-currency').empty();        
        $('.lang-currency').append($(".currency-lists ."+cookieCurrency).text());        
        
      };
  
  
      
/* ---------------------------------------------
     Loadmore Product
 --------------------------------------------- */
      var first_click  = false; 
      $(document).on('click','.button-loadmore',function(event){
        event.preventDefault();
        var name = $(this).attr('name');
        var link = $(this).attr('title');
        $( '#' + name + ' li.hidden').css({'-webkit-animation-delay':'0ms','-o-animation-delay':'0ms','animation-delay':'0ms'});
        $( '#' + name + ' li.hidden').removeClass("hidden");
        $(this).text("VIEW MORE!");
        if(first_click ){
         location.href='/collections/'+link;
        };
        first_click = true;
      })
      
      $("#quick-view-modal button.close").on('click', function(){
        $('#modal-cart').remove();
      })
      

        $('[data-toggle=\'tooltip\']').tooltip({
            container: 'body'
        });
       
      
/* ---------------------------------------------
     Scroll top jquery
--------------------------------------------- */ 
        $("#scroll-top").on('click', function(event) {
            event.preventDefault();
            /* Act on the event */
          $("html, body").animate({ scrollTop: 0 }, "slow");
        });
      
/* ---------------------------------------------
     Change View
--------------------------------------------- */ 
      
      var view_mode  = $.localStorage;

      /*var get_view_mode = view_mode.get('view_mode');
      setTimeout(function(){
        if(get_view_mode == 'grid'){
          $(".products-grid-view").trigger('click');         
        }else{
          $(".products-list-view").trigger('click');          
        }
      }, 2000);	*/
      
	  $('.products-grid-view').on('click', function(event) {
        event.preventDefault();
        
        $('.products-change-view').removeClass('active');
        
        $(".products-grid-view").addClass('active');

        var view = $(this).data('view');
      
        view_mode.set('view_mode',view);		
       
        $(".products").find('li.product-item').hide();        
        $(".products").find('li.product-item.view-'+view).css('display','inline-block');
        
        if (view == 'list') {
          $("#collection-product").removeClass('products-grid');
          $("#collection-product").addClass( 'products-list');
        }
        if (view == 'grid') {
          $("#collection-product").removeClass('products-list');
          $("#collection-product").addClass( 'products-grid');        
        }
        $(".page-number.current").trigger('click');
      });
      
      $('.products-list-view').on('click', function(event) {
        event.preventDefault();
        
        $('.products-change-view').removeClass('active');
        
        $(".products-list-view").addClass('active');

        var view = $(this).data('view');
        
        view_mode.set('view_mode',view);		
       
        $(".products").find('li.product-item').hide();        
        $(".products").find('li.product-item.view-'+view).css('display','inline-block');
        
        if (view == 'list') {
          $("#collection-product").removeClass('products-grid');
          $("#collection-product").addClass( 'products-list');
        }
        if (view == 'grid') {
          $("#collection-product").removeClass('products-list');
          $("#collection-product").addClass( 'products-grid');        
        }
        $(".page-number.current").trigger('click');
      });
      
      
/* ---------------------------------------------
     Quantity Product Page
--------------------------------------------- */ 
    $(document).on('keyup',"#Quantity", function(event) {                            
      var textinput = $(this).val();                      
      $(this).attr('value',textinput);
    });
     $(document).on('click',".up", function(event) {
      var max = parseInt($("#Quantity").attr("data-max"))
      var quan = parseInt($("#Quantity").val());
      quan = quan+1;
      if (quan <= max){
        var zero;
        if(quan<10){
          zero = "0"+quan;
        }
        else{
          zero=quan;
        }
      }else{
       // zero="01"+quan;
        zero="01";
      }
      $('.down').css('pointer-events', 'auto'); 
      $("#Quantity").val(zero).attr('value',zero);
      
    });
    $(document).on('click',".down", function(event) {
      var quan = parseInt($("#Quantity").val());                        
      quan = quan-1;
      var zero;
      if(quan<10){
        zero = "0"+quan;
      }
      else{
        zero=quan;
      }
      $("#Quantity").val(zero).attr('value',zero);
      if(quan == 1){
        $('.down').css('pointer-events', 'none');
      }
      if(quan == 100){
        $('.down').css('pointer-events', 'none');
      }
      
    });  
        
    $(document).on("click","[id^='count_']", function(event) {      
      event.preventDefault();
      var id = $(this).attr('id');
        $(".product-item").hide();                  
        $(".product-list-grid li").addClass('hide');        
        $(".page_"+id).removeClass('hide');

          $(".navigation li").removeClass("active");
            $(this).parent().addClass("active");

        var view =$(".change-view.active").data('view');
        if(view == 'list') {
          $(".view-list").show();
        } 
        else{
          $(".view-grid").show();
        }
        var num = parseInt($(this).text()) ;
        console.log(num);

        $('html, body').animate({scrollTop: 0}, 800);            

    });
      
/* ---------------------------------------------
     Order product
 --------------------------------------------- */
      $(window).load(function() {
        $("[href^='#tab-1-']").trigger("click");
      });
      $(document).on("click","ul.home17 li.kiti a", function(event) {
        event.preventDefault();
        var $view = $(this).data('view');
        var $handle = $(this).data('handle');
        var $block_id = $(this).attr('href');
        

        if ($handle != "") {
          $.ajax({
            url: '/collections/' + $handle,
            type: 'GET',
            dataType: 'html',
            data: {
              view: 'json',
              sort_by: $view
            },
            success: function(responsive) {
              $( $block_id ).html(responsive);
              var $block = $( $block_id ).find('.owl-carousel');
              var config = $block.data();
              $block.owlCarousel(config);
            }
          });
        }
      });
/* ---------------------------------------------
     Icon cart click
 --------------------------------------------- */      
      $(document).on("click",".icon-cart", function(event) {
        event.preventDefault();
        show_dropdown_cart();
        
      });

      
      $(document).on("click",".btn_add_review", function(event) {        
        $(".review_tab").trigger("click");        
      });

      $(document).on("change","#productSelect", function(event) {        
       		   
      });
      
/* ---------------------------------------------
     Slider product in product page
--------------------------------------------- */            
       $(document).on("click",".img-product-thumb", function(event) {        
       		var url = $(this).find('img').attr('src');  
         	url = url.replace("small", "1024x1024");
         
         	$(".first-image").find('img').attr('src',url);
      });
      $(document).on("change","#search_option", function(event){
        console.log($(this).val());
         $.cookie("remmember_search_option", $(this).val());
        $("#main_search").val("");
      })
      
     
      if($.cookie("remmember_search_option")!=null){
        $("#search_option").val($.cookie("remmember_search_option"));        
        var title_search_option = $('#search_option option:selected').text();
        $("#search_option_chosen a span").text(title_search_option);
        
      }
      $(document).on("click","#search_option_chosen",function(event){
         var index = $('#search_option').prop('selectedIndex');
         $(".active-result").removeClass("highlighted");
         $(".active-result").removeClass("result-selected");
         $("[data-option-array-index^='"+ index +"']").addClass("result-selected");
         $("#search_option").trigger("change");
      })
      
      if($('#main_search').length>0){
          var val_current_search = $("#main_search").val();
          var val_search = "";
          if(val_current_search != ""){
            var n = val_current_search.indexOf(":");  
            if(n != -1){
              val_search = val_current_search.substr(n+1);
            }
          } 

           if(val_search != ""){
             $("#main_search").val(val_search);         
           }
      }
      $(document).on("click",".btn-search", function(event){       
        
        var val_search = $("#main_search").val(); 
        if(val_search!=""){
          $("#main_search").val($("#search_option").val()+":"+val_search); 
          $(".form-search").submit();  
        }else{
          window.location.reload();
        }
              
         return false;
      })
      
      // clear all item of cart page
      $('#clear_all_cart').on('click',function(e){
        e.preventDefault();
        $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          success: function(){            
            sweetAlert("Information", "Cart is cleared!", "success");
            window.location.reload();
          },
          dataType: 'json'
        });
      })
      
      $("[id^='span_'] a").on('click',function(){       	 	
        	return true;        	
      })
      $('[id^="chk_"]').on('click',function(e){
         var id= $(this).attr("name");        	
         var href = $("#span_"+id).find("a").attr('href');
         window.location.href = href;
      })
      
      
      $("[id^='span_brand_'] a").on('click',function(){       	 	
        	return true;        	
      })
      
      $('[id^="chk_brand_"]').on('click',function(e){
         var id= $(this).attr("name");        	
         var href = $("#span_brand_"+id).find("a").attr('href');
         window.location.href = href;
      })      
      
      var count = 0;
               
      if($("#Quantity").attr("data-max") == 0){
        $("#Quantity").val($("#Quantity").attr("data-max"));
      }
      
      $(".quantity-plus").on('click',function(e){
        count++;
        if (count > parseInt($("#Quantity").attr("data-max"))){
          	$("#Quantity").val($("#Quantity").attr("data-max"));
            $(this).click(false);
        }else{
          	 $(this).click(true);
        }        
      })
      $(".quantity-minus").on('click',function(e){
        count--;
        if (count > parseInt($("#Quantity").attr("data-max"))){
            $("#Quantity").val($("#Quantity").attr("data-max"));
            $('.quantity-plus').click(false);
        }else{
          	$('.quantity-plus').click(true);
        }     
        if(count<0){
          count=0;
        }
      })
     
      
    });
})(jQuery);

